module.exports = __webpack_public_path__ + "static/media/info.8071a6b5.svg";